import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GifIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gif"}/>
}
